import { render, staticRenderFns } from "./AppointmentListCard.vue?vue&type=template&id=1d9f70ef&scoped=true&"
import script from "./AppointmentListCard.vue?vue&type=script&lang=ts&"
export * from "./AppointmentListCard.vue?vue&type=script&lang=ts&"
import style0 from "./AppointmentListCard.vue?vue&type=style&index=0&id=1d9f70ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9f70ef",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VChip,VCol,VContainer,VDivider,VIcon,VRow})
